import { render } from "./RiepilogoDatiUtenteTicket.vue?vue&type=template&id=19c32433"
import script from "./RiepilogoDatiUtenteTicket.vue?vue&type=script&lang=js"
export * from "./RiepilogoDatiUtenteTicket.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__